<template>
  <div>
    <Heading heading="Assignment Attachments" />
    <UiMultiUploadFile
      id="input-assignment"
      v-model="fieldValue"
      :rules="imageRules"
      name="ASSIGNMENT_ATTACHMENTS"
      title="ASSIGNMENT_ATTACHMENTS"
      :hide-title="true"
      :is-file-loading="isFileLoading"
      accept-format="image/png, image/jpeg, image/jpg, application/pdf"
      @change="uploadAttachments"
      @removeFile="removeFile"
    />
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch, onMounted, computed } from 'vue'

// Components
import Heading from '@src/components/Heading.vue'
import UiMultiUploadFile from '@src/components/UiElements/UiMultiUploadFile.vue'
import RULE_CONSTANTS from '@src/constants/rule.constants.js'
// Store
import { useStore } from 'vuex'

const store = useStore()
const props = defineProps({ modelValue: { default: () => [], type: Array } })
const emits = defineEmits(['update:modelValue', 'isFileLoading'])

// States
let attachments = ref([])
let fieldValue = ref([])
const isFileLoading = ref(false)
//computed
const imageRules = computed(() => {
  return `${RULE_CONSTANTS.SIZE}|${RULE_CONSTANTS.FILE_LIMIT}`
})
// Watch
watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue.length) attachments.value = newValue
    emits('update:modelValue', attachments.value)
    fieldValue.value = attachments.value
  },
)

watch(
  () => attachments.value,
  () => attachmentsHandler(),
)

// Mounted hook
onMounted(() => {
  attachmentsHandler()
})

// Methods
const getSizeInKB = (size) => {
  return (size / 1000).toFixed(2)
}
const errorFile = ref([])
const uploadAttachments = async (files) => {
  errorFile.value = []
  isFileLoading.value = true
  emits('isFileLoading', true)

  const form = new FormData()

  files.forEach((file, index) => {
    if (isFileNameUnique(file.name) && getSizeInKB(file.size) <= 500) {
      form.append(`assignment_attachment[${index}]`, file)
    } else {
      errorFile.value.push(file)
    }
  })

  const formDataEntries = Array.from(form.entries())

  if (formDataEntries.length) {
    uploadAssignmentAttachments(form)
      .then((response) => {
        emits('isFileLoading', true)
        const attachment = response.data
        attachment.forEach((item) => {
          attachments.value.push(item)
        })
      })
      .finally(() => {
        attachments.value.push(...errorFile.value)
        fieldValue.value = attachments.value
        emits('isFileLoading', false)
        isFileLoading.value = false
      })
  } else {
    setTimeout(() => {
      attachments.value.push(...errorFile.value)
      fieldValue.value = attachments.value
      emits('isFileLoading', false)
      isFileLoading.value = false
    }, 500)
  }
}
const attachmentsHandler = () => {
  emits('update:modelValue', attachments.value)
}
const removeFile = (index) => {
  attachments.value = fieldValue.value
}
const isFileNameUnique = (fileName) => {
  return !fieldValue.value?.some((file) => file && (file.name || file.file_name) === fileName)
}
// Actions
const uploadAssignmentAttachments = (payload) =>
  store.dispatch('assignment/uploadAssignmentAttachments', payload)
</script>
